module.exports = __webpack_public_path__ + "static/img/about_empowerment.3fe46d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_empowerment.png
// module id = +z8U
// module chunks = 2